module.exports = __webpack_public_path__ + "img/purple.bbf9a6f7.png";